export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover a agenda <strong>' + this.currentEntity.name + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/index/resources/computed.js